import { Component, OnInit } from '@angular/core';
import { constants } from 'src/app/shared/constants';
import { ErrorService } from 'src/app/shared/services/error.service';
import { ItsmService } from 'src/app/shared/services/itsm.service';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import * as Highcharts from 'highcharts';
// import LegoData from '../../../../assets/lego.json';
import { graphconstants } from './graphconstants';
import { DataPoint, PieFormat, SecurityCaseActivity } from './chartModels';
import { Utilities } from 'src/app/shared/utilities';
import { Router } from '@angular/router';
import { SupportCaseSearchCriteria } from 'src/app/shared/model/searchCriteria';


@Component({
  selector: 'app-report-live-securitycase',
  templateUrl: './report-live-securitycase.component.html',
  styleUrls: ['./report-live-securitycase.component.scss']
})
export class ReportLiveSecurityCaseComponent implements OnInit {
  data: any[];
  currentMonthDataTP: any[];
  currentMonthDataFP: any[];
  totalTP: number;
  totalFP: number;

  page: string;
  subpage: string;
  killchainView : "bar" | "ring" = "bar";
  actionView : "bar" | "ring" = "ring";
  assetView : "bar" | "ring" = "bar";

  monthIndex: number;
  currentMonth: string;

  caseMap: Map<string, SecurityCaseActivity>;

  Highcharts: typeof Highcharts = Highcharts;
  updateFlag = false;
  updateDonutFlag = false;

  xCat = [];
  actors = [];
  actions = [];
  subactions = [];
  attributes = [];
  assets = [];
  killchains = [];
  what = [];
  who = [];
  why = [];

  sortedBy: string;
  sortedOrder: number;

  loaded: boolean;
  errorMessage: string;

  catColumnChartOptions = {
    colors: constants.graphColors,
    chart: {
      type: 'column'
    },
    credits: {
      enabled : false
    },
    legend: {
      enabled : true
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    xAxis:{
        categories: [],
        crosshair: true,
       
    },
    yAxis : {  
        min: 0,
        title: {
          text: 'Cases'
        },
        stackLabels: {
          enabled: true,
          style: {
              fontWeight: 'bold',
              color: ( // theme
                  Highcharts.defaultOptions.title.style &&
                  Highcharts.defaultOptions.title.style.color
              ) || 'gray'
          }
      }
    },
    tooltip: {
        headerFormat: '',
        pointFormat: '{series.name}: {point.y}'
    },
    plotOptions: {
      column: {
          stacking: 'normal',
          dataLabels: {
              enabled: true
          }
      }
  },
    series: []
  };

  tpvfpDonutChartOptions = JSON.parse(JSON.stringify(graphconstants.pieChartOption));

  actorDonutChartOptions = JSON.parse(JSON.stringify(graphconstants.pieChartOption));
  actionDonutChartOptions = JSON.parse(JSON.stringify(graphconstants.pieChartOption));
  actionBarChartOptions = JSON.parse(JSON.stringify(graphconstants.columnChartOptions));
  killchainColumnChartOptions = JSON.parse(JSON.stringify(graphconstants.columnChartOptions));
  killchainDonutChartOptions = JSON.parse(JSON.stringify(graphconstants.pieChartOption));
  attributesChartOptions = JSON.parse(JSON.stringify(graphconstants.columnChartOptions));
  assetDonutChartOptions = JSON.parse(JSON.stringify(graphconstants.pieChartOption));
  assetBarChartOptions = JSON.parse(JSON.stringify(graphconstants.columnChartOptions));
  subactionDonutChartOptions = JSON.parse(JSON.stringify(graphconstants.pieChartOption));

  whatDonutChartOptions = JSON.parse(JSON.stringify(graphconstants.pieChartOption));
  whoDonutChartOptions = JSON.parse(JSON.stringify(graphconstants.pieChartOption));
  whyDonutChartOptions = JSON.parse(JSON.stringify(graphconstants.pieChartOption));

  //Modal
  closeResult: string;
  PDFName: string="";
  reportOption: string = "csv";
  pdfAccessLevel : string = "0";
  searchCriteria : SupportCaseSearchCriteria;
  reportGenerated : boolean = null;
  generateReportLoading = false;

  constructor(private itsmService: ItsmService,
              private errorService: ErrorService,
              private modalService: NgbModal,
              private router: Router) { }

  ngOnInit() {
    this.whatDonutChartOptions.plotOptions.series = {
      cursor: 'pointer',
      events: {
          click: (event) => {
              this.prepareCurrentMonthData("whatFalsePositive", event.point.name, false);
          }
      }
    }
    this.whoDonutChartOptions.plotOptions.series = {
      cursor: 'pointer',
      events: {
          click: (event) => {
              this.prepareCurrentMonthData("whoFalsePositive", event.point.name, false);
          }
      }
    }
    this.whyDonutChartOptions.plotOptions.series = {
      cursor: 'pointer',
      events: {
          click: (event) => {
              this.prepareCurrentMonthData("whyFalsePositive", event.point.name, false);
          }
      }
    }
      this.attributesChartOptions.plotOptions.series = {
        cursor: 'pointer',
        events: {
            click: (event) => {
                this.prepareCurrentMonthData("attributes", event.point.name, true);
            }
        }
      }
      this.assetDonutChartOptions.plotOptions.series = {
        cursor: 'pointer',
        events: {
            click: (event) => {
                this.prepareCurrentMonthData("u_asset", event.point.name, true);
            }
        }
      }
      this.assetBarChartOptions.plotOptions.series = {
        cursor: 'pointer',
        events: {
            click: (event) => {
                this.prepareCurrentMonthData("u_asset", event.point.name, true);
            }
        }
      }
      this.subactionDonutChartOptions.plotOptions.series = {
        cursor: 'pointer',
        events: {
            click: (event) => {
                this.prepareCurrentMonthData("subAction", event.point.name, true);
            }
        }
    }
    this.actionDonutChartOptions.plotOptions.series = {
      cursor: 'pointer',
      events: {
          click: (event) => {
              this.prepareCurrentMonthData("action", event.point.name, true);
          }
      }
    }
    this.actionBarChartOptions.plotOptions.series = {
      cursor: 'pointer',
      events: {
          click: (event) => {
              this.prepareCurrentMonthData("action", event.point.name, true);
          }
      }
    }
    this.actorDonutChartOptions.plotOptions.series = {
      cursor: 'pointer',
      events: {
          click: (event) => {
              this.prepareCurrentMonthData("actor", event.point.name, true);
          }
      }
    }
    this.killchainColumnChartOptions.plotOptions.series = {
      cursor: 'pointer',
      events: {
          click: (event) => {
              this.prepareCurrentMonthData("killchain", event.point.name, true);
          }
      }
    }
    this.killchainDonutChartOptions.plotOptions.series = {
      cursor: 'pointer',
      events: {
          click: (event) => {
              this.prepareCurrentMonthData("killchain", event.point.name, true);
          }
      }
    }
    this.loaded = false;
    this.itsmService.securityIncidentReport(Utilities.get6MonthsAgo())
      .then(res => {
        // res = JSON.parse(localStorage.getItem("SecTempData"))
        // temporary work around for ServiceNow, so only Incidents are used
        // see https://securelink-eu.atlassian.net/browse/GP-481 for the explanation of the issue and correct fix
        this.data = res.filter(t => (t.type !== "Change Request") && (t.type !== "Service Request"));
        if(this.data && this.data.length > 0){
          this.caseMap = new Map();

          this.totalFP = 0;
          this.totalTP = 0;
      
          this.page = 'tp';
          this.subpage = 'analytics';
      
          this.data.forEach(c => {
      
            let cd = new Date(c.createdDate);
            let actualMonth = cd.getMonth()+1;
            let dateStr = cd.getFullYear() + "-" + actualMonth;
      
            if(!this.caseMap.get(dateStr)){
              this.caseMap.set(dateStr, new SecurityCaseActivity(dateStr));
            }
      
            if(Utilities.checkTruePositive(c.caseNumber, c.status, c.closureCode)){
              let caseM = this.caseMap.get(dateStr);
              caseM.truePositives.push(c);
              this.totalTP++;
              if(c.action){
  
                let actionM = this.caseMap.get(dateStr);
                if(actionM.action.get(c.action)){
                  actionM.action.set(c.action, actionM.action.get(c.action)+1);
                }else{
                  actionM.action.set(c.action, 1);
                }
                this.caseMap.set(dateStr, actionM);
              }
        
              if(c.subAction){
                let subactionM = this.caseMap.get(dateStr);
                if(subactionM.subAction.get(c.subAction)){
                  subactionM.subAction.set(c.subAction, subactionM.subAction.get(c.subAction)+1);
                }else{
                  subactionM.subAction.set(c.subAction, 1);
                }
                this.caseMap.set(dateStr, subactionM);
              }
        
              if(c.killchain){
                 
                let killchainM = this.caseMap.get(dateStr);
                let killchains = [];
                if(c.killchain.includes(';')){
                  killchains = c.killchain.split(';');
                }else{
                  killchains.push(c.killchain);
                }
        
                killchains.forEach(kc => {
                  if(killchainM.killChain.get(kc)){
                    killchainM.killChain.set(kc, killchainM.killChain.get(kc)+1);
                  }else{
                    killchainM.killChain.set(kc, 1);
                  }
                  this.caseMap.set(dateStr, killchainM);
                })
              }
              if(c.u_asset){
                 
                let assetM = this.caseMap.get(dateStr);
                let u_asset = [];
                if(c.u_asset.includes(';')){
                  u_asset = c.u_asset.split(';');
                }else{
                  u_asset.push(c.u_asset);
                }
        
                u_asset.forEach(kc => {
                  if(assetM.u_asset.get(kc)){
                    assetM.u_asset.set(kc, assetM.u_asset.get(kc)+1);
                  }else{
                    assetM.u_asset.set(kc, 1);
                  }
                  this.caseMap.set(dateStr, assetM);
                })
              }
        
              if(c.actor){ 
                let actorM = this.caseMap.get(dateStr);
                if(actorM.actor.get(c.actor)){
                  actorM.actor.set(c.actor, actorM.actor.get(c.actor)+1);
                }else{
                  actorM.actor.set(c.actor, 1);
                }
                this.caseMap.set(dateStr, actorM);
              }
        
              if(c.attributes){
                let attributeM = this.caseMap.get(dateStr);
                if(attributeM.attributes.get(c.attributes)){
                  attributeM.attributes.set(c.attributes, attributeM.attributes.get(c.attributes)+1);
                }else{
                  attributeM.attributes.set(c.attributes, 1);
                }
                this.caseMap.set(dateStr, attributeM);
              }
            }else if(Utilities.checkFalsePositive(c.status, c.closureCode)){
              let caseM = this.caseMap.get(dateStr);
              caseM.falsePositives.push(c);
              this.totalFP++;

              if(c.whatFalsePositive){
                let whatM = this.caseMap.get(dateStr);
                if(whatM.whatFalsePositive.get(c.whatFalsePositive)){
                  whatM.whatFalsePositive.set(c.whatFalsePositive, whatM.whatFalsePositive.get(c.whatFalsePositive)+1);
                }else{
                  whatM.whatFalsePositive.set(c.whatFalsePositive, 1);
                }
                this.caseMap.set(dateStr, whatM);
              }
        
              if(c.whyFalsePositive){
                let whyM = this.caseMap.get(dateStr);
                if(whyM.whyFalsePositive.get(c.whyFalsePositive)){
                  whyM.whyFalsePositive.set(c.whyFalsePositive, whyM.whyFalsePositive.get(c.whyFalsePositive)+1);
                }else{
                  whyM.whyFalsePositive.set(c.whyFalsePositive, 1);
                }
                this.caseMap.set(dateStr, whyM);
              }
        
              if(c.whoFalsePositive){
                let whoM = this.caseMap.get(dateStr);
                if(whoM.whoFalsePositive.get(c.whoFalsePositive)){
                  whoM.whoFalsePositive.set(c.whoFalsePositive, whoM.whoFalsePositive.get(c.whoFalsePositive)+1);
                }else{
                  whoM.whoFalsePositive.set(c.whoFalsePositive, 1);
                }
                this.caseMap.set(dateStr, whoM);
              }
            }
             
           
      
          
      
            if(c.asset && c.asset.Name){
              let assNameM = this.caseMap.get(dateStr);
              if(assNameM.assetName.get(c.asset.Name)){
                assNameM.assetName.set(c.asset.Name, assNameM.attributes.get(c.asset.Name)+1);
              }else{
                assNameM.assetName.set(c.asset.Name, 1);
              }
              this.caseMap.set(dateStr, assNameM);
            }
      
            if(c.asset && c.asset.Vendor){
              let assVenM = this.caseMap.get(dateStr);
              if(assVenM.assetVendor.get(c.asset.Vendor)){
                assVenM.assetVendor.set(c.asset.Vendor, assVenM.attributes.get(c.asset.Vendor)+1);
              }else{
                assVenM.assetVendor.set(c.asset.Vendor, 1);
              }
              this.caseMap.set(dateStr, assVenM);
            }
      
          });
      
          this.caseMap = new Map([...this.caseMap.entries()].reverse());
      
          this.caseMap.forEach(cm => {
            this.xCat.push(cm.date.slice(5) + '/' + cm.date.slice(0,4));
      
            cm.actor.forEach((k,y) => {
              if(!this.actors.includes(y)){
                this.actors.push(y);
              }
            });
      
            cm.action.forEach((k,y) => {
              if(!this.actions.includes(y)){
                this.actions.push(y);
              }
            });
      
            cm.subAction.forEach((k,y) => {
              if(!this.subactions.includes(y)){
                this.subactions.push(y);
              }
            });
      
            cm.attributes.forEach((k,y) => {
              if(!this.attributes.includes(y)){
                this.attributes.push(y);
              }
            });
      
            cm.killChain.forEach((k,y) => {
              if(!this.killchains.includes(y)){
                this.killchains.push(y);
              }
            });
            cm.u_asset.forEach((k,y) => {
              if(!this.assets.includes(y)){
                this.assets.push(y);
              }
            });
      
            cm.whatFalsePositive.forEach((k,y) => {
              if(!this.what.includes(y)){
                this.what.push(y);
              }
            });
      
            cm.whoFalsePositive.forEach((k,y) => {
              if(!this.who.includes(y)){
                this.who.push(y);
              }
            });
      
            cm.whyFalsePositive.forEach((k,y) => {
              if(!this.why.includes(y)){
                this.why.push(y);
              }
            });
      
            this.actors.sort();
            this.actions.sort();
            this.killchains.sort();
            this.assets.sort();
            this.attributes.sort();
            this.subactions.sort();
            this.what.sort();
            this.who.sort();
            this.why.sort();
            
          });
      
          this.updateGraph('action');
          this.updateOverviewGraph();
      
          this.monthIndex = Array.from(this.caseMap).length-1;
          let cmdate = Array.from(this.caseMap)[this.monthIndex][0];
          this.currentMonth = cmdate.slice(5) + '/' + cmdate.slice(0,4);
          this.currentMonthDataTP = Array.from(this.caseMap)[this.monthIndex][1].truePositives;
          this.currentMonthDataFP = Array.from(this.caseMap)[this.monthIndex][1].falsePositives;
          this.formatAllPieChartData(this.monthIndex);
      
          this.loaded = true;

        }else{
          this.loaded = true;
          this.errorMessage = "Unfortunately there is no suitable data available to generate this report."
        }

      })
      .catch(err => {
        this.errorService.handlerError(err);
      });
    
  }

  prepareCurrentMonthData(series, seriesName, posi){
      let dynamicData = []
       
      this.data.forEach(c => {
        if(posi && !Utilities.checkTruePositive(c.caseNumber, c.status, c.closureCode)){
          return
        }
        if(!posi && !Utilities.checkFalsePositive(c.status, c.closureCode)){
          return
        }
          let cd = new Date(c.createdDate);
          let actualMonth = cd.getMonth()+1;
          let dateStr = cd.getFullYear() + "-" + actualMonth;
          let cmdate = Array.from(this.caseMap)[this.monthIndex][0]
            
          if (cmdate == dateStr && c[series]){
            let seriesList = c[series].split(',')
             
            if(seriesList.length>1){
              seriesList.forEach(element => {
                if(element.toLowerCase() == seriesName.toLowerCase()){
                dynamicData.push(c)
                }
              });
            }
            else{
              if(c[series] == seriesName){
                dynamicData.push(c)
              }
            }
          }
        
       
      
       
    })
    if(posi){
    this.currentMonthDataTP = dynamicData
    }
    else{this.currentMonthDataFP = dynamicData}
    this.subpage = 'data'
  }
  updateOverviewGraph(){
    let dataItems = [];

    let pieSeries = new DataPoint();
    pieSeries.type = 'pie';
    pieSeries.innerSize = '50%';
    pieSeries.name = "True Positive vs False Positive";

    let item1 = {
      name: "True Positive",
      y: this.totalTP,
      indicator: "TPO"
    }
    dataItems.push(item1);
    let item2 = {
      name: "False Positive",
      y: this.totalFP,
      indicator: "FPO"
    }
    dataItems.push(item2);

    // switch count to percentage
    dataItems.forEach(di => {
      di.y = +((di.y / (this.totalFP + this.totalTP)) * 100).toFixed(1);
    })
    pieSeries.data = dataItems;      
    let series = [];
    series.push(pieSeries)
    this.tpvfpDonutChartOptions.plotOptions.series = {
      cursor: 'pointer',
      events: {
          click: (event) => {
              this.router.navigateByUrl('/support/dashboard/' + event.point.indicator);
          }
      }
  }
    this.tpvfpDonutChartOptions.series = series;
    this.tpvfpDonutChartOptions.title.text = '<strong>' + (this.totalFP + this.totalTP) + '<br/>cases</strong>';
  }

  updateGraph(datapoint: string){
    let series = [];
    let typeTitle = '';

    if(datapoint === 'actor'){
      typeTitle = 'Actor';

      this.actors.forEach(act => {

        let seriesObj = new DataPoint();
        seriesObj.name = act;
        let seriesObjData = [];

        this.caseMap.forEach(cm => {
          if(!cm.actor.get(act)){
            seriesObjData.push(0);
          }else{
            seriesObjData.push(cm.actor.get(act));
          }
        });

        seriesObj.data = seriesObjData
        series.push(seriesObj);

      });

    }else if(datapoint === 'action'){
        typeTitle = 'Action';

        this.actions.forEach(act => {
        
          let seriesObj = new DataPoint();
          seriesObj.name = act;
          let seriesObjData = [];
  
          this.caseMap.forEach(cm => {
            if(!cm.action.get(act)){
              seriesObjData.push(0);
            }else{
              seriesObjData.push(cm.action.get(act));
            }
          });
  
          seriesObj.data = seriesObjData
          series.push(seriesObj);
  
        });

    }else if(datapoint === 'subaction'){
        typeTitle = 'Sub Action';

        this.subactions.forEach(act => {
        
          let seriesObj = new DataPoint();
          seriesObj.name = act;
          let seriesObjData = [];
  
          this.caseMap.forEach(cm => {
            if(!cm.subAction.get(act)){
              seriesObjData.push(0);
            }else{
              seriesObjData.push(cm.subAction.get(act));
            }
          });
  
          seriesObj.data = seriesObjData
          series.push(seriesObj);
  
        });

    }else if(datapoint === 'killchain'){
        typeTitle = 'Kill Chain';
         
        this.killchains.forEach(act => {
        
          let seriesObj = new DataPoint();
          seriesObj.name = act;
          let seriesObjData = [];
  
          this.caseMap.forEach(cm => {
            if(!cm.killChain.get(act)){
              seriesObjData.push(0);
            }else{
              seriesObjData.push(cm.killChain.get(act));
            }
          });
  
          seriesObj.data = seriesObjData
          series.push(seriesObj);

        });


    }
    else if(datapoint === 'u_asset'){
      typeTitle = 'Asset';
       
      this.assets.forEach(act => {
      
        let seriesObj = new DataPoint();
        seriesObj.name = act;
        let seriesObjData = [];

        this.caseMap.forEach(cm => {
          if(!cm.u_asset.get(act)){
            seriesObjData.push(0);
          }else{
            seriesObjData.push(cm.u_asset.get(act));
          }
        });

        seriesObj.data = seriesObjData
        series.push(seriesObj);

      });


  }
  else if(datapoint === 'attributes'){
        typeTitle = 'Attributes';

        this.attributes.forEach(act => {
        
          let seriesObj = new DataPoint();
          seriesObj.name = act;
          let seriesObjData = [];
  
          this.caseMap.forEach(cm => {
            if(!cm.attributes.get(act)){
              seriesObjData.push(0);
            }else{
              seriesObjData.push(cm.attributes.get(act));
            }
          });
  
          seriesObj.data = seriesObjData
          series.push(seriesObj);

        });

    }

    this.catColumnChartOptions.xAxis.categories = this.xCat;
       
    this.catColumnChartOptions.series = [...series];
    this.catColumnChartOptions.title.text = 'Threat ' + typeTitle;
    this.updateFlag = true;
  }

  changeMonth(direction: string){
    if(direction === 'fwd'){
      if(Array.from(this.caseMap).length < this.monthIndex++){
        this.monthIndex++;
      }
    }else if(direction === 'back'){
      if(this.monthIndex > 0){
        this.monthIndex--;
      }
    }
    let cmdate = Array.from(this.caseMap)[this.monthIndex][0];
    this.currentMonth = cmdate.slice(5) + '/' + cmdate.slice(0,4);
    this.currentMonthDataTP = Array.from(this.caseMap)[this.monthIndex][1].truePositives;
    this.currentMonthDataFP = Array.from(this.caseMap)[this.monthIndex][1].falsePositives;

    this.formatAllPieChartData(this.monthIndex);
  }
  dataTabClicked(){
    this.currentMonthDataFP = Array.from(this.caseMap)[this.monthIndex][1].falsePositives;
    this.currentMonthDataTP = Array.from(this.caseMap)[this.monthIndex][1].truePositives;
  }

  // Construct data for a piechart for a given datapoint
  formatPieData(donutChartOptions: PieFormat, objectMap: Map<string, number>, objectType: string, allvalues: string[], totalCountArg?: number){
    // format data for actor
    let totalCount = 0;
    let dataItems = [];
    let categories = {}   
    let categoriesList = []

    allvalues.forEach((cat) => {
      if(cat.split(',').length == 1){
        if (categoriesList.indexOf(cat) == -1){
          categoriesList.push(cat)
          categories[cat] = 0
        }
      }
      else{
        let tempCat = cat.split(',')
        tempCat.forEach((item)=>{
          if (categoriesList.indexOf(item) == -1){
            categoriesList.push(item)
            categories[item] = 0
          }
        })
      }
    })


    let pieSeries = new DataPoint();
    pieSeries.type = 'pie';
    pieSeries.innerSize = '50%';
    pieSeries.name = objectType;

    allvalues.forEach(v => {
      const keys = v.split(',');
       
      keys.forEach((key,index) => {
        if(objectMap.get(v)){
          categories[key] += objectMap.get(v)
          if(index==0){
            totalCount += objectMap.get(v);
          }
        }
      })
    });

    dataItems = Object.entries(categories).map(([name, cases]) => ({name, cases, y: +((Number(cases) / (totalCount)) * 100).toFixed(1)}))


    pieSeries.data = dataItems;      
    let series = [];
    series.push(pieSeries);
    donutChartOptions.series = series;
    donutChartOptions.title.text = '<strong>' + (totalCountArg ? totalCountArg: totalCount) + '<br/>cases</strong>';

  }

  // Construct data for a bar chart for a given datapoint
  formatAssetColumnData(barChartOptions: any, objectMap: Map<string, number>, objectType: string, allvalues: string[], initialCategoryList? : string[], orderHighestToLowest = false){
    // format data for actor
    let totalCount = 0;
    let dataItems = [];
    let categories = {};
    let categoriesList = initialCategoryList ?? [];
    initialCategoryList?.forEach(cat => {
      categories[cat] = 0;
    })
     
    allvalues.forEach((cat) => {
      if(cat.split(',').length == 1){
        if (categoriesList.indexOf(cat) == -1){
          categoriesList.push(cat)
          categories[cat] = 0
        }
      }
      else{
        let tempCat = cat.split(',')
        tempCat.forEach((item)=>{
          if (categoriesList.indexOf(item) == -1){
            categoriesList.push(item)
            categories[item] = 0
          }
        })
      }
    })

    barChartOptions.xAxis.categories = categoriesList

    let barSeries = new DataPoint();
    barSeries.innerSize = '50%';
    barSeries.name = objectType;
    barSeries.showInLegend = false;
     
    allvalues.forEach(v => {
      const keys = v.split(',');
       
      keys.forEach((key,index) => {
        if(objectMap.get(v)){
          categories[key] += objectMap.get(v)
          if(index==0){
            totalCount += objectMap.get(v);
          }
        }
      })
    });

    dataItems = Object.entries(categories).map(([name, cases]) => ({name, cases, y: +((Number(cases) / (totalCount)) * 100).toFixed(1)}))

    if(orderHighestToLowest) {
      dataItems.sort((i1, i2) => (i2.y - i1.y) )
    }
    
    // set chart data
    barSeries.data = dataItems;      
    let series = [];
    series.push(barSeries);
    barChartOptions.series = series;

  }
    // Construct data for a bar chart for a given datapoint
    formatColumnData(barChartOptions: PieFormat, objectMap: Map<string, number>, objectType: string, allvalues: string[], totalCountArg?: number){
      // format data for actor
      let totalCount = 0;
      let dataItems = [];
      let categories = {
        no_impact : 0,
        confidentiality : 0,
        integrity : 0,
        availability : 0,
      }
      let barSeries = new DataPoint();
      barSeries.innerSize = '50%';
      barSeries.name = objectType;
      barSeries.showInLegend = false;
 
      allvalues.forEach(v => {
        const keys = v.split(',');
         
        keys.forEach((key,index) => {
          if(objectMap.get(v)){
            categories[key] += objectMap.get(v)
            if(index==0){
              totalCount += objectMap.get(v);
            }
          }
        })
      });
  
      dataItems = Object.entries(categories).map(([name, cases]) => ({name, cases, y: +((cases / totalCount) * 100).toFixed(1)}))


      // set chart data
      barSeries.data = dataItems;      
      let series = [];
      series.push(barSeries);
      barChartOptions.series = series;
    }

  // format all pie charts
  formatAllPieChartData(monthOffset: number){
    let pieSeries = new DataPoint();
    pieSeries.type = 'pie';
    pieSeries.innerSize = '50%';

    let latestMonth = Array.from(this.caseMap)[monthOffset][1];
    this.formatPieData(this.actorDonutChartOptions, latestMonth.actor, 'Actor', this.actors);
    this.formatPieData(this.actionDonutChartOptions, latestMonth.action, 'Action', this.actions);
    this.formatAssetColumnData(this.actionBarChartOptions, latestMonth.action, 'Action', this.actions, null, true);
    this.formatPieData(this.subactionDonutChartOptions, latestMonth.subAction, 'Sub Actions', this.subactions);
    
    const initialCategoryList = [
      "reconnaissance",
      "policy_breach",
      "initial_compromise",
      "persistence",
      "command_and_control",
      "privilege_escalation",
      "lateral_movement",
      "manipulation_and_evasion",
      "data_exfiltration",
      "n_a"
    ];
    this.formatAssetColumnData(this.killchainColumnChartOptions, latestMonth.killChain, 'Killchain', this.killchains, initialCategoryList);
    this.formatPieData(this.killchainDonutChartOptions, latestMonth.killChain, 'Killchain', this.killchains);
     
    this.formatPieData(this.assetDonutChartOptions, latestMonth.u_asset, 'Asset', this.assets);
    this.formatAssetColumnData(this.assetBarChartOptions, latestMonth.u_asset, 'Asset', this.assets);

    this.formatColumnData(this.attributesChartOptions, latestMonth.attributes, 'Attributes', this.attributes);
    this.formatPieData(this.whyDonutChartOptions, latestMonth.whyFalsePositive, 'Why', this.why);
    this.formatPieData(this.whatDonutChartOptions, latestMonth.whatFalsePositive, 'What', this.what);
    this.formatPieData(this.whoDonutChartOptions, latestMonth.whoFalsePositive, 'Who', this.who);

    // let previousMonth = Array.from(this.caseMap)[monthOffset+1][1];
    // this.formatPieData(this.actorPreviousDonutChartOptions, previousMonth.actor, 'Actor', this.actors);
    // this.formatPieData(this.actionPreviousDonutChartOptions, previousMonth.action, 'Action', this.actions);
    // this.formatPieData(this.subactionPreviousDonutChartOptions, previousMonth.subAction, 'Sub Actions', this.subactions);
    // this.formatPieData(this.killchainPreviousDonutChartOptions, previousMonth.killChain, 'Killchain', this.killchains);
    // this.formatPieData(this.attributesPreviousDonutChartOptions, previousMonth.attributes, 'Attributes', this.attributes);

    this.updateDonutFlag = true;
  }


  sortAssets(field: string){
    if(this.sortedBy === field){
      if(this.sortedOrder == -1) {
        this.sortedOrder = 1;
        this.currentMonthDataFP.sort(function(a, b){
          if(a[field] < b[field]) { return 1; }
          if(a[field] > b[field]) { return -1; }
          return 0;
        });
        this.currentMonthDataTP.sort(function(a, b){
          if(a[field] < b[field]) { return 1; }
          if(a[field] > b[field]) { return -1; }
          return 0;
        });
      }else{
        this.sortedOrder = -1;
        this.currentMonthDataFP.sort(function(a, b){
          if(a[field] < b[field]) { return -1; }
          if(a[field] > b[field]) { return 1; }
          return 0;
        });
        this.currentMonthDataTP.sort(function(a, b){
          if(a[field] < b[field]) { return -1; }
          if(a[field] > b[field]) { return 1; }
          return 0;
        });
      }
    }else{
      this.sortedBy = field;
      this.sortedOrder = 1;
      this.currentMonthDataFP.sort(function(a, b){
        if(a[field] < b[field]) { return -1; }
        if(a[field] > b[field]) { return 1; }
        return 0;
      });
      this.currentMonthDataTP.sort(function(a, b){
        if(a[field] < b[field]) { return -1; }
        if(a[field] > b[field]) { return 1; }
        return 0;
      });
    }
  }

  exportReport(content){
    this.openModal(content)
  }
  
  openModal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

      if(result == 'save'){
       this.generateCsvReport();
      }

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  
  generateCsvReport(){
    this.generateReportLoading = true;
    this.searchCriteria = new SupportCaseSearchCriteria();

    this.searchCriteria.count = false;
    this.searchCriteria.limit = undefined;
    this.searchCriteria.securityAnaltyics = true;
    this.searchCriteria.export = true;
    this.searchCriteria.pdfName = this.PDFName +  ' - ' + constants.accessLevels[this.pdfAccessLevel] +  "." + this.reportOption;
    this.searchCriteria.pdfAccessLevel = this.pdfAccessLevel;
    this.searchCriteria.extended = true;
    this.searchCriteria.status = 'Closed';
    this.searchCriteria.escalation = 'To Customer,from Customer';
  
    this.itsmService.caseSearch(this.searchCriteria)
      .then(res => {
        this.reportGenerated = true;
        this.generateReportLoading = false;
      })
      .catch(err => {
        this.errorService.handlerError(err);
        this.generateReportLoading = false;
      });

    
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  closeAlert(){
    this.reportGenerated = null;
    console.log("close");
  }
}
